$(document).ready(function () {

    // modify the body class when scrolled
    $(window).on('scroll', _.debounce(function() {

        var currScroll = $(window).scrollTop();
        var navHeight = $('.navbar').height() * .25;
        var windowHeight = $(window).height() * .5;

        // add scrolled class when past nav
        if (currScroll >= 83) {
            $('body').addClass('scrolled');
        } else {
            $('body').removeClass('scrolled');
        }

    }, 4));

});

// Event Tracking for Freshpaint
import 'OchsnerJS/common/_freshpaint-event-tracking.js';
